export const PartnerCode = {
  VNPT: 'VNPT',
  MINVOICE: 'MINVOICE',
  SUN: 'SUN',
  VIETTEL: 'VIETTEL',
  VNPT_V5: 'VNPT_V5',
  MISA: 'MISA',
  CYBER_BILL: 'CYBER_BILL',
  CMC: 'CMC',
  FAST: 'FAST',
  EASY: 'EASY'
}